// removed by extract-text-webpack-plugin
module.exports = {"App":"_1nSs9jxTrYw7ShEn0Erqzg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Econom/style.css
// module id = 329
// module chunks = 0